import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AutenticacionService } from './autenticacion.service';
import { Cuestionario } from '../_models/cuestionario';

@Injectable({
  providedIn: 'root'
})
export class CuestionarioService {

  private rutServiciosCuestionarios = AppSettings.rutServiciosAPL + '/api/cuestionarios/';

  constructor( private httpClient: HttpClient, private autenticacionService: AutenticacionService ) {
  }

  listado(): Observable<Cuestionario[]> {
    return this.httpClient.get( this.rutServiciosCuestionarios ).pipe( map( res => res as Cuestionario[] ) );
  }


  listadoConRespuesta() {
    return this.httpClient.get( this.rutServiciosCuestionarios + 'preguntasWithRespuestas' ).pipe( map( res => res as Cuestionario[] ) );
  }

  obtener( idRespuesta: string ): Observable<Cuestionario> {
    return this.httpClient.get( this.rutServiciosCuestionarios + idRespuesta ).pipe( map( res => res as Cuestionario ) );
  }

  agregar( cuestionario: Cuestionario ): Observable<Cuestionario> {
    cuestionario.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    cuestionario.auditoriaFecha = new Date( Date.now() );
    return this.httpClient.post( this.rutServiciosCuestionarios, cuestionario ).pipe( map( res => res as Cuestionario ) );
  }

  actualizar( cuestionario: Cuestionario ): Observable<any> {
    return this.httpClient.put( this.rutServiciosCuestionarios, cuestionario ).pipe( map( res => res as any ) );
  }

  bulk( cuestionarios: Cuestionario[] ) {
    const idUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    cuestionarios.map( x => {
      x.auditoriaUsuario = idUsuario;
    } )
    return this.httpClient.post( this.rutServiciosCuestionarios + 'bulk', cuestionarios ).pipe( map( res => res as any ) );
  }
}
